/* eslint-disable */
export default {
  removeMeetingWarning: '会议安排功能已停用。请使用 {app} 安排视频会议。',
  scheduleMeetingTips:
    '请注意，我们已从此应用中移除会议。如需使用会议，我们建议您使用 {app}。',
  migrateToPluginAlert:
    '注意：此应用不支持 Outlook 2016（及以下版本）和 Internet Explorer 11。请升级您的 Outlook 或切换到 Microsoft Edge，或者切换到 {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
